<template>
  <v-container class="dark-overlay" :class="{small}">
    <v-row justify="center" class="fill-height" align="center">
      <v-col>
        <v-row justify="center">
          {{$t(error.title)}}
        </v-row>
        <v-row justify="center" style="text-align: center">
          <span class="subtitle-2">{{$t(error.description)}}</span>
        </v-row>
        <v-row justify="center" :class="{'pt-5':!small}">
          <v-btn @click="$emit('dismiss')">{{$t('general.ok')}}</v-btn>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: "RecordingError",
    props:{
      error:{},
      small : {
        type:Boolean,
        default:false
      }
    }
  }
</script>

<style scoped>
  .dark-overlay{
    font-family: Roboto, sans-serif;
    font-size: 18pt;
    background-color: black;
    opacity: 0.7;
    width:100%;
    height:100%;
    font-weight: bold;
  }

  .dark-overlay.small{
    font-size: 12pt;
  }

  .dark-overlay.small .subtitle-2{
    font-size: 12px!important;
  }

</style>